
import Vue from "vue";
import DeviceRequestBill from "@/assets/js/Bill/DeviceRequestBill";
import HttpUtil from "@/assets/js/HttpUtil";
import Urls from "@/assets/js/Urls";
export default Vue.extend({
  props: ["type"],
  components: {},
  data() {
    return {
      props: {
        label: "groupName",
        children: "children",
      },
      items: [] as any,
      search: null as any,
      currentPage: 1,
      pageSize: 6,
      total: 0,
      choosedItem: [] as string[],
      groups: [] as any[],
    };
  },
  async mounted() {
    await this.getGroups();
  },
  watch: {
    type() {
      this.getGroups();
    },
  },
  methods: {
    handleCheckChange(data: any, checked: any, indeterminate: any) {
      console.log(data, checked, indeterminate);
    },
    handleSelectionChange(val: any) {
      this.choosedItem = [];
      val.forEach((x: any) => {
        this.choosedItem.push(x.sid);
      });
    },
    getData() {
      const tree: any = this.$refs.tree;
      const list: any[] = tree.getCheckedNodes();
      this.choosedItem = [];
      list.forEach((ele: any) => {
        if (ele && ele.sid) {
          this.choosedItem.push(ele.sid);
        }
      });
      return this.choosedItem;
    },
    async getGroups() {
      const ret: any = await HttpUtil.XCHttpPost(Urls.GetSoftGroups, 0, true, false);
      this.groups = [
        {
          groupName: "根目录",
          sid: null,
          children: ret,
        },
      ];
    },
  },
});
